module.exports = __webpack_public_path__ + "img/a9.0b6bbf73.png";